import { gql } from '@apollo/client/core'

export const GET_PROJECT_BY_ID = gql`
  query getById($id: Int!) {
    plan_by_pk(Id: $id) {
      Id
      ProjectId
      SystemId
      Name
      Address
      DateAdded
      Latitude
      Longitude
      Height
      NumberOfTurbines
      EvaluationArea
      AvgSelWindSpeed
      AvgWindOutput
      CombinedYearlyWindOutput
      MaxWindOutput
      MinWindOutput
      TotalYearlyWindOutput
      WindSpeedRoseData
      WindSpeedHistogram
      MaxSelWindSpeed
      PolygonCoordinates
      DateModified
      OwnerId
    }
  }
`

export const GET_PROJECTS = gql`
  query getPlans($order_by: PlanOrderByInput!) {
    plans(orderBy: $order_by, first: 2000) {
      items {
        Id
        SystemId
        Installer
        Name
        Address
        Height
        NumberOfTurbines
        MaxWindOutput
        MaxSelWindSpeed
        EvaluationArea
      }
    }
  }
`

export const GET_PROJECTS_WITH_ORG = gql`
  query getPlans($order_by: PlanOrderByInput!) {
    plans(orderBy: $order_by, first: 1000) {
      items {
        Id
        SystemId
        Installer
        Name
        Address
        Height
        NumberOfTurbines
        MaxWindOutput
        MaxSelWindSpeed
        EvaluationArea
        Organization {
          Name
        }
        User {
          Name
        }
      }
    }
  }
`

export const GET_PROJECTS_WITH_ORG_FILTER = gql`
  query getPlans($order_by: PlanOrderByInput!, $filter: PlanFilterInput!) {
    plans(orderBy: $order_by, filter: $filter, first: 2000) {
      items {
        Id
        SystemId
        ProjectId
        SalesforceId
        Installer
        Name
        Address
        Height
        NumberOfTurbines
        MaxWindOutput
        MaxSelWindSpeed
        EvaluationArea
        AddressMatchConfidence
        Organization {
          Name
        }
        User {
          Name
        }
      }
    }
  }
`

export const CREATE_PROJECT = gql`
  mutation CreateProject(
    $Name: String
    $OwnerId: UUID!
    $Address: String
    $DateAdded: DateTime
    $DateModified: DateTime
    $Latitude: Float
    $Longitude: Float
    $Height: Int
    $NumberOfTurbines: Int
    $EvaluationArea: String
    $AvgSelWindSpeed: Decimal
    $AvgWindOutput: Decimal
    $MaxSelWindSpeed: Decimal
    $MaxWindOutput: Decimal
    $MinSelWindSpeed: Decimal
    $MinWindOutput: Decimal
    $CombinedYearlyWindOutput: Decimal
    $TotalYearlyWindOutput: String
    $WindSpeedRoseData: String
    $WindSpeedHistogram: String
    $Installer: String
    $PolygonCoordinates: String
  ) {
    createPlan(
      item: {
        Name: $Name
        OwnerId: $OwnerId
        Address: $Address
        DateAdded: $DateAdded
        DateModified: $DateModified
        Latitude: $Latitude
        Longitude: $Longitude
        Height: $Height
        NumberOfTurbines: $NumberOfTurbines
        EvaluationArea: $EvaluationArea
        AvgSelWindSpeed: $AvgSelWindSpeed
        AvgWindOutput: $AvgWindOutput
        MaxSelWindSpeed: $MaxSelWindSpeed
        MaxWindOutput: $MaxWindOutput
        MinSelWindSpeed: $MinSelWindSpeed
        MinWindOutput: $MinWindOutput
        CombinedYearlyWindOutput: $CombinedYearlyWindOutput
        TotalYearlyWindOutput: $TotalYearlyWindOutput
        WindSpeedRoseData: $WindSpeedRoseData
        WindSpeedHistogram: $WindSpeedHistogram
        Installer: $Installer
        PolygonCoordinates: $PolygonCoordinates
      }
    ) {
      Id
      OwnerId
      ProjectId
      Name
      Address
      DateAdded
      DateModified
      Latitude
      Longitude
      Height
      NumberOfTurbines
      EvaluationArea
      AvgSelWindSpeed
      AvgWindOutput
      MaxSelWindSpeed
      MaxWindOutput
      MinSelWindSpeed
      MinWindOutput
      CombinedYearlyWindOutput
      TotalYearlyWindOutput
      WindSpeedRoseData
      WindSpeedHistogram
      Installer
      PolygonCoordinates
    }
  }
`

export const UPDATE_PROJECT = gql`
  mutation UpdateProject(
    $Id: Int!
    $Name: String
    $Address: String
    $Latitude: Float
    $Longitude: Float
    $Height: Int
    $NumberOfTurbines: Int
    $EvaluationArea: String
    $AvgSelWindSpeed: Decimal
    $AvgWindOutput: Decimal
    $MaxSelWindSpeed: Decimal
    $MaxWindOutput: Decimal
    $MinSelWindSpeed: Decimal
    $MinWindOutput: Decimal
    $CombinedYearlyWindOutput: Decimal
    $TotalYearlyWindOutput: String
    $WindSpeedRoseData: String
    $WindSpeedHistogram: String
    $Installer: String
    $PolygonCoordinates: String
    $DateModified: DateTime
  ) {
    updatePlan(
      Id: $Id
      item: {
        Name: $Name
        Address: $Address
        Latitude: $Latitude
        Longitude: $Longitude
        Height: $Height
        NumberOfTurbines: $NumberOfTurbines
        EvaluationArea: $EvaluationArea
        AvgSelWindSpeed: $AvgSelWindSpeed
        AvgWindOutput: $AvgWindOutput
        MaxSelWindSpeed: $MaxSelWindSpeed
        MaxWindOutput: $MaxWindOutput
        MinSelWindSpeed: $MinSelWindSpeed
        MinWindOutput: $MinWindOutput
        CombinedYearlyWindOutput: $CombinedYearlyWindOutput
        TotalYearlyWindOutput: $TotalYearlyWindOutput
        WindSpeedRoseData: $WindSpeedRoseData
        WindSpeedHistogram: $WindSpeedHistogram
        Installer: $Installer
        PolygonCoordinates: $PolygonCoordinates
        DateModified: $DateModified
      }
    ) {
      Id
      OwnerId
      SystemId
      ProjectId
      Name
      DateAdded
      Address
      Latitude
      Longitude
      Height
      NumberOfTurbines
      EvaluationArea
      AvgSelWindSpeed
      AvgWindOutput
      MaxSelWindSpeed
      MaxWindOutput
      MinSelWindSpeed
      MinWindOutput
      CombinedYearlyWindOutput
      TotalYearlyWindOutput
      WindSpeedRoseData
      WindSpeedHistogram
      Installer
      PolygonCoordinates
      DateModified
    }
  }
`

export const GET_PROSPECTS = gql`
  query getProspects($order_by: ProspectOrderByInput!) {
    prospects(orderBy: $order_by, first: 2000) {
      items {
        Id
        Area
        Address
        Country
        PostalCode
        PostalDistrict
        AvgWindSpeed
        Pct90WindSpeed
        Latitude
        Longitude
        prospectingArea {
          Id
          Name
        }
      }
    }
  }
`

export const GET_PROSPECTS_FILTER = gql`
  query getProspects($order_by: ProspectOrderByInput!, $filter: ProspectFilterInput!) {
    prospects(orderBy: $order_by, filter: $filter, first: 2000) {
      items {
        Id
        Address
        Country
        PostalCode
        PostalDistrict
        AvgWindSpeed
        Pct90WindSpeed
        Latitude
        Longitude
        prospectingArea {
          Id
          Name
        }
      }
    }
  }
`

export const GET_PROSPECTAREAS = gql`
  query getProspectingAreas($order_by: ProspectingAreaOrderByInput!) {
    prospectingAreas(orderBy: $order_by, filter: { FinishedEstimation: { eq: true } }) {
      items {
        Id
        Name
        FinishedEstimation
      }
    }
  }
`

export const GET_USER_INFO = gql`
  query getUserInfo($filter: UserFilterInput!) {
    users(filter: $filter) {
      items {
        Name
        Organization {
          Name
        }
      }
    }
  }
`

export const GET_ALL_ORGS = gql`
  query getOrgs {
    organizations {
      items {
        Name
        Id
      }
    }
  }
`

export const GET_ALL_BATCHES = gql`
  query getBatches($order_by: BatchOrderByInput!) {
    batches(orderBy: $order_by) {
      items {
        Name
        Id
      }
    }
  }
`
